import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product" }
const _hoisted_2 = { class: "product__media" }
const _hoisted_3 = { class: "product__data" }
const _hoisted_4 = { class: "product__title" }
const _hoisted_5 = ["datetime"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Try it")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageBox = _resolveComponent("ImageBox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("figure", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _ctx.getProductPath(_ctx.item.name, _ctx.item.importedFrom),
        tabindex: "-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ImageBox, {
            width: "300",
            height: "300",
            src: _ctx.getImagePath(_ctx.item.imagePath),
            alt: _ctx.item.name,
            fill: "#fff"
          }, null, 8, ["src", "alt"])
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: _ctx.getProductPath(_ctx.item.name, _ctx.item.importedFrom),
          tabindex: "-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.name), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("time", {
        class: "product__date",
        datetime: _ctx.item.createdDate
      }, _toDisplayString(_ctx.formatDate(_ctx.item.createdDate)), 9, _hoisted_5)
    ]),
    _createVNode(_component_Button, {
      format: "link",
      href: _ctx.getProductPath(_ctx.item.name, _ctx.item.importedFrom),
      width: "block",
      instance: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["href"])
  ]))
}